import { useState, useEffect } from "react";
import axios from "axios";
import Header from "../Components/Header";
import Card from "../Components/Card";
import { BRAND } from "../css/brand";
import TabButton from "../Components/Tabbutton";
import BlueButton from "../Components/BlueButton";
import Select from "react-select";
import Swal from "sweetalert2";
import PullBackFlow from "./PullBackFlow";
import { fetchRoles, getRoleName } from "../Data/ROLES"; // ✅ dynamic roles
import SimpleTable from "../Components/SimpleTable";
import Badge from "../Components/Badge";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ReceivedKeysTable from "../Components/ReceivedKeysTable";
import AssignedKeysReport from "../Components/AssignedKeysReport";
import PullbackKeysReport from "../Components/PullbackKeysReport";
import { CornerUpLeft, Download, FileText, Key, RefreshCw, RotateCcw, Wallet } from "lucide-react";
import Loader from "../Components/Loader";
import GoBackButton from "../Components/GoBackButton";
import TableSkeleton from "../Components/TableSkeleton";

export default function Keys() {
  // console.log("role from keys: ", role)
  const [tab, setTab] = useState("assign");

  // Assign Key States
  const [keyType, setKeyType] = useState("Smart");
  const [packageType, setPackageType] = useState("");
  const [numKeys, setNumKeys] = useState("");
  const [keyRate, setKeyRate] = useState("");
  const [totalAmount, setTotalAmount] = useState("");
  const [selectedRetailer, setSelectedRetailer] = useState("");
  const [retailers, setRetailers] = useState([]);

  const [totalRetailers, setTotalRetailer] = useState(0);
  const [packages, setPackages] = useState([]);
  const [roles, setRoles] = useState([]);
  const [selectedRole, setSelectedRole] = useState("");

  const [receivedReports, setReceivedReports] = useState([]);
  const [receivePage, setReceivePage] = useState(1);
  const rowsPerPage = 10;
  const [errorReceive, setErrorReceive] = useState(null);
  const [loadingReceive, setLoadingReceive] = useState(false);
  const [receiveTotalPages, setReceiveTotalPages] = useState(1);

  const [assignedReports, setAssignedReports] = useState([]);
  const [loadingReport, setLoadingReport] = useState(false);
  const [errorReport, setErrorReport] = useState(null);
  const [reportPage, setReportPage] = useState(1);
  const [reportTotalPages, setReportTotalPages] = useState(1);

  const [balanceTab, setBalanceTab] = useState("");

// 🔹 Set default sub-tab based on user role
  

  const [balanceData, setBalanceData] = useState([]);
  const [loadingBalance, setLoadingBalance] = useState(false);
  const [errorBalance, setErrorBalance] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);

  const [searchTerm, setSearchTerm] = useState("");
  const [fromDate1, setFromDate1] = useState("");
  const [toDate1, setToDate1] = useState("");
  // const rowsPerPage = 10; // you can change this to 5, 20, etc.

  const [pullbackReports, setPullbackReports] = useState([]);
  const [loadingReceived, setLoadingReceived] = useState(false);
  const [errorReceived, setErrorReceived] = useState(null);
  const [receivedTotalPages, setReceivedTotalPages] = useState(1);

  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");


  const authUserString = sessionStorage.getItem("authUserData1");
  const authUser = JSON.parse(authUserString);
  const loginUserID = authUser?.data[0]?.id;
  const CompanyID = authUser?.data[0]?.company_id;
  const userRole = authUser?.data[0]?.role;

  useEffect(() => {
    if (tab === "retailer-balance" && !balanceTab) {
      const userRole = authUser?.data[0]?.role;
      if (userRole === 2) setBalanceTab("cnf");
      else if (userRole === 3) setBalanceTab("superstockist");
      else if (userRole === 4) setBalanceTab("distributor");
      else if (userRole === 5) setBalanceTab("retailer");
    }
  }, [tab]);

  // ✅ Fetch roles (excluding role 2)
  useEffect(() => {
  async function loadRoles() {
    const data = await fetchRoles();
    const userRole = authUser?.data[0]?.role;
    console.log("role from session: ", userRole)
    let filtered = [];

    if (userRole === 2) {
      // Company → CNF, Super Stockist, Distributor, Retailer
      filtered = Object.entries(data)
        .filter(([id]) => [3, 4, 5, 7].includes(Number(id)))
        .map(([id, name]) => ({ value: Number(id), label: name }));
    } else if (userRole === 3) {
      // CNF → Super Stockist, Distributor, Retailer
      filtered = Object.entries(data)
        .filter(([id]) => [4, 5, 7].includes(Number(id)))
        .map(([id, name]) => ({ value: Number(id), label: name }));
    } else if (userRole === 4) {
      // Super Stockist → Distributor, Retailer
      filtered = Object.entries(data)
        .filter(([id]) => [5, 7].includes(Number(id)))
        .map(([id, name]) => ({ value: Number(id), label: name }));
    } else if (userRole === 5) {
      // Distributor → FOS and Retailer
      filtered = Object.entries(data)
        .filter(([id]) => [6, 7].includes(Number(id)))
        .map(([id, name]) => ({ value: Number(id), label: name }));
    }
    else if (userRole === 6) {
      // fos →  Retailer
      filtered = Object.entries(data)
        .filter(([id]) => [7].includes(Number(id)))
        .map(([id, name]) => ({ value: Number(id), label: name }));
    }

    // optional: FOS first, then Retailer
    filtered.sort((a, b) => a.value - b.value);

    setRoles(filtered);
  }
  loadRoles();
}, []);

  // ✅ Fetch retailers based on selected role
  useEffect(() => {
  if (!selectedRole || !loginUserID) return;

  const userRole = authUser?.data[0]?.role;
  const baseURL = "https://spillas.com/api/v1/org_user";

  let paramKey = "";
  if (userRole == 2) paramKey = "company_id";
  else if (userRole === 3) paramKey = "cnf_id";
  else if (userRole === 4) paramKey = "ss_id";
  else if (userRole === 5) paramKey = "dist_id";
  else if (userRole === 6) paramKey = "fos_id";

  const apiUrl = `${baseURL}?role=${selectedRole}&page=1&per_page=10000&${paramKey}=${loginUserID}`;
  console.log("Fetching users from:", apiUrl);

  axios
    .get(apiUrl)
    .then((res) => {
      const data = res.data.data || res.data || [];
      setRetailers(data);
      setTotalRetailer(res.data.total || data.length || 0);
    })
    .catch((err) => console.error("Failed to load retailers:", err));
}, [selectedRole, loginUserID]);

  // Fetch available packages
  useEffect(() => {
    if (!loginUserID) return;
    axios
      .get(
        `https://spillas.com/api/v1/keys/all-my-package-list?receiver_id=${loginUserID}`
      )
      .then((res) => setPackages(res.data.data || []))
      .catch((err) => console.error(err));
  }, [loginUserID]);

  // Auto calculate total
  useEffect(() => {
    const total = parseInt(numKeys || 0) * parseFloat(keyRate || 0);
    setTotalAmount(isNaN(total) ? "" : total.toFixed(2));
  }, [numKeys, keyRate]);

  // Filter packages by key type
  const filteredPackages = packages.filter((pkg) => {
    if (keyType === "Regular") return pkg.key_type === 1;
    if (keyType === "Smart") return pkg.key_type === 2;
    return false;
  });

  const handleAssign = async () => {
  const selectedPkg = packages.find((pkg) => pkg.id.toString() === packageType);
  if (!selectedPkg) {
    Swal.fire("Error", "Please select a package", "error");
    return;
  }

  const selectedRetailerData = retailers.find((r) => r.id === selectedRetailer);
  if (!selectedRetailerData) {
    Swal.fire("Error", "Please select a user", "error");
    return;
  }

  const userRole = authUser?.data[0]?.role;
  const userId = authUser?.data[0]?.id;
  const userName = authUser?.data[0]?.business_name;
  const userCode = authUser?.data[0]?.org_code;
  const userCompanyId = authUser?.data[0]?.company_id;
  const userCompanyName = authUser?.data[0]?.company_name;
  const userCnfId = authUser?.data[0]?.cnf_id;
  const userCnfName = authUser?.data[0]?.cnf_name;
  const userSsId = authUser?.data[0]?.ss_id;
  const userSsName = authUser?.data[0]?.ss_name;

  // 🧠 Common payload
  const payload = {
    sender_id: userId,
    sender_name: userName,
    sender_code: userCode,

    receiver_name:
      selectedRetailerData.business_name || selectedRetailerData.Shop_Name,
    receiver_code:
      selectedRetailerData.org_code || selectedRetailerData.RetailerCode,
    receiver_id: selectedRetailerData.id,
    key_rate: keyRate,
    qty: numKeys,
    amount: totalAmount,
    key_type: selectedPkg.key_type,
    mode: 1,
    role: selectedRole,
    package_name: selectedPkg.package_name,
    product_id: selectedPkg.product_id,
    user_package_id: selectedPkg.id,

    created_by_id: userId,
    created_by_name: userName,
    created_by_code: userCode,
    created_by_role: userRole,
  };

  // 🧩 Add hierarchy based on role
  if (userRole === 2) {
    // Company
    payload.company_id = userId;
    payload.company_name = userName;
  } else if (userRole === 3) {
    // CNF
    payload.company_id = userCompanyId;
    payload.company_name = userCompanyName;
    payload.cnf_id = userId;
    payload.cnf_name = userName;
  } else if (userRole === 4) {
    // Super Stockist
    payload.company_id = userCompanyId;
    payload.company_name = userCompanyName;
    payload.cnf_id = userCnfId;
    payload.cnf_name = userCnfName;
    payload.ss_id = userId;
    payload.ss_name = userName;
  } else if (userRole === 5) {
    // Distributor
    payload.company_id = userCompanyId;
    payload.company_name = userCompanyName;
    payload.cnf_id = userCnfId;
    payload.cnf_name = userCnfName;
    payload.ss_id = userSsId;
    payload.ss_name = userSsName;
    payload.dist_id = userId;
    payload.dist_name = userName;
  }

  // 🧾 Optional balance_keys
  payload.balance_keys = selectedPkg.qty;

  Swal.fire({
    title: `Assigning keys to ${payload.receiver_name}...`,
    text: "Please wait",
    allowOutsideClick: false,
    didOpen: () => Swal.showLoading(),
  });

  try {
    await axios.post("https://spillas.com/api/v1/keys/assign", payload);
    Swal.fire(
      "Success ✅",
      `Keys assigned successfully to ${payload.receiver_name}`,
      "success"
    );

    // Reset form
    setPackageType("");
    setNumKeys("");
    setKeyRate("");
    setTotalAmount("");
    setSelectedRetailer("");
  } catch (err) {
    console.error(err);
    Swal.fire("Error ❌", "Failed to assign keys. Please try again.", "error");
  }
};

  const getRoleIdFromTab = (tabName) => {
  switch (tabName) {
    case "cnf":
      return 3;
    case "superstockist":
      return 4;
    case "distributor":
      return 5;
    case "retailer":
      return 7;
    default:
      return null;
  }
};

  useEffect(() => {
  if (tab !== "retailer-balance" || !balanceTab) return;

  const userRole = authUser?.data[0]?.role;
  const userId = authUser?.data[0]?.id;

  if (!userRole || !userId) return;

  let parentParam = "";
  if (userRole === 2) parentParam = `company_id=${userId}`;
  else if (userRole === 3) parentParam = `cnf_id=${userId}`;
  else if (userRole === 4) parentParam = `ss_id=${userId}`;
  else if (userRole === 5) parentParam = `dist_id=${userId}`;

  const roleParam = getRoleIdFromTab(balanceTab);
  let apiUrl = `https://spillas.com/api/v1/keys/user-balance-list?role=${roleParam}&${parentParam}`;

  // ✅ Smart search detection
  if (searchTerm.trim()) {
    const prefixMap = {
      CNF: "CNF",
      "Super Stockist": "SS",
      Distributor: "DIST",
      "Micro Distributor": "MD",
      Retailer: "RTL",
    };

    const orgPrefix = prefixMap[balanceTab] || "";

    if (searchTerm.toUpperCase().startsWith(orgPrefix)) {
      apiUrl += `&receiver_code=${encodeURIComponent(searchTerm.toUpperCase())}`;
    } else if (searchTerm.length >= 3) {
      apiUrl += `&receiver_name=${encodeURIComponent(searchTerm)}`;
    } else {
      // Do not fetch for too-short names
      return;
    }
  }

  if (fromDate1) apiUrl += `&from_date=${fromDate1}`;
  if (toDate1) apiUrl += `&to_date=${toDate1}`;

  console.log("📦 Fetching balance list:", apiUrl);

  setLoadingBalance(true);
  setErrorBalance(null);

  axios
    .get(apiUrl)
    .then((res) => {
      let data = res.data || [];
      data = data.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
      setBalanceData(data);
    })
    .catch((err) => {
      console.error("❌ Failed to load balance data:", err);
      setErrorBalance("Failed to fetch balance data");
    })
    .finally(() => setLoadingBalance(false));
}, [tab, balanceTab, searchTerm, fromDate1, toDate1]);


 // ✅ added balanceTab as dependency

  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = balanceData.slice(indexOfFirstRow, indexOfLastRow);
  const totalPages = Math.ceil(balanceData.length / rowsPerPage);

  // 🔹 CSV Download Handler
const handleDownload = async () => {
  try {
    const userRole = authUser?.data[0]?.role;
    const userId = authUser?.data[0]?.id;

    if (!userRole || !userId) {
      alert("Missing user details");
      return;
    }

    let parentParam = "";
    if (userRole === 2) parentParam = `company_id=${userId}`;
    else if (userRole === 3) parentParam = `cnf_id=${userId}`;
    else if (userRole === 4) parentParam = `ss_id=${userId}`;
    else if (userRole === 5) parentParam = `dist_id=${userId}`;

    const roleParam = getRoleIdFromTab(balanceTab);
    let apiUrl = `https://spillas.com/api/v1/keys/user-balance-list?role=${roleParam}&${parentParam}&page=1&per_page=10000`;

    // ✅ Smart search logic (same as in useEffect)
    if (searchTerm.trim()) {
      const prefixMap = {
        CNF: "CNF",
        "Super Stockist": "SS",
        Distributor: "DIST",
        "Micro Distributor": "MD",
        Retailer: "RTL",
      };

      const orgPrefix = prefixMap[balanceTab] || "";

      if (searchTerm.toUpperCase().startsWith(orgPrefix)) {
        apiUrl += `&receiver_code=${encodeURIComponent(searchTerm.toUpperCase())}`;
      } else if (searchTerm.length >= 3) {
        apiUrl += `&receiver_name=${encodeURIComponent(searchTerm)}`;
      } else {
        alert("Enter at least 3 characters to search");
        return;
      }
    }

    if (fromDate1) apiUrl += `&from_date=${fromDate1}`;
    if (toDate1) apiUrl += `&to_date=${toDate1}`;

    console.log("⬇️ Download URL:", apiUrl);

    const res = await axios.get(apiUrl);
    const rows = res.data || [];

    if (!rows.length) {
      alert("No data to download");
      return;
    }

    const headers = [
      "Sr No.",
      "User Code",
      "User Name",
      ...(balanceTab === "cnf"
        ? ["Company"]
        : balanceTab === "superstockist"
        ? ["Company", "CNF"]
        : balanceTab === "distributor"
        ? ["Company", "CNF", "Super Stockist"]
        : balanceTab === "retailer"
        ? ["Company", "CNF", "Super Stockist", "Distributor"]
        : []),
      "Assign Date",
      "Remaining",
    ];

    const csvRows = [
      headers.join(","),
      ...rows.map((item, i) => {
        const baseRow = [
          i + 1,
          item.receiver_code || "N/A",
          item.receiver_name || item.name || "-",
        ];

        const dynamicCols =
          balanceTab === "cnf"
            ? [item.company_name]
            : balanceTab === "superstockist"
            ? [item.company_name, item.cnf_name || "-"]
            : balanceTab === "distributor"
            ? [item.company_name, item.cnf_name || "-", item.ss_name || "-"]
            : balanceTab === "retailer"
            ? [
                item.company_name,
                item.cnf_name || "-",
                item.ss_name || "-",
                item.distributor_name || "-",
              ]
            : [];

        const assignDate = item.created_at
          ? new Date(item.created_at).toLocaleDateString()
          : "-";

        return [...baseRow, ...dynamicCols, assignDate, item.smart_qty || 0].join(",");
      }),
    ];

    const blob = new Blob([csvRows.join("\n")], { type: "text/csv" });
    const urlObject = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = urlObject;
    link.download = `retailer_balance_${balanceTab}.csv`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(urlObject);
  } catch (error) {
    console.error("❌ Failed to download CSV:", error);
    alert("Failed to download report");
  }
};



  return (
    <div className="space-y-3 sm:space-y-4">
      <GoBackButton/>
      <Header brand={BRAND} title="Keys">
      </Header>

      <div className="flex justify-end flex-wrap gap-2 text-xs sm:text-sm">
        <TabButton
            active={tab === "assign"}
            onClick={() => setTab("assign")}
            className="flex items-center gap-2 px-3 py-1.5"
          >
            <Key size={16} />
            <span>Assign</span>
          </TabButton>


        <TabButton active={tab === "receive"} onClick={() => setTab("receive")}>
          <Download size={14} />
          <span className="hidden sm:inline">Receive</span>
        </TabButton>

        <TabButton active={tab === "report"} onClick={() => setTab("report")}>
          <FileText size={14} />
          <span className="hidden sm:inline">Assigned Report</span>
        </TabButton>

        {userRole === 2 && (
          <TabButton active={tab === "pullback-report"} onClick={() => setTab("pullback-report")}>
            <RotateCcw size={14} />
            <span className="hidden sm:inline">Pullback Report</span>
          </TabButton>
        )}

        <TabButton active={tab === "retailer-balance"} onClick={() => setTab("retailer-balance")}>
          <Wallet size={14} />
          <span className="hidden sm:inline">User Balance</span>
        </TabButton>

        {userRole === 2 && (
          <TabButton active={tab === "pullback"} onClick={() => setTab("pullback")}>
            <CornerUpLeft size={14} />
            <span className="hidden sm:inline">Pull Back</span>
          </TabButton>
        )}
      </div>

      {/* ==================== Assign Keys ==================== */}
      {tab === "assign" && (
        <Card brand={BRAND} title="Assign Keys">
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
            {/* ✅ Role Select */}
            <div>
              <label className="text-sm font-medium text-gray-700 mb-1 block">
                Select Role
              </label>
              <Select
                options={roles}
                value={roles.find((r) => r.value === selectedRole) || null}
                onChange={(opt) => {
                  if (!opt) {
                    // 🧹 When cleared — reset user-related states
                    setSelectedRole("");
                    setSelectedRetailer("");
                    setRetailers([]);
                    setTotalRetailer(0);
                    return;
                  }

                  // ✅ When a role is selected — update normally
                  setSelectedRole(opt.value);
                  setSelectedRetailer("");
                  setRetailers([]);
                }}
                placeholder="Select Role..."
                isClearable
              />
            </div>

            {/* ✅ Retailer Select */}
            <div>
              <label className="text-sm font-medium text-gray-700 mb-1 block">
                Select User
              </label>
              <Select
                options={retailers.map((ret) => ({
                  value: ret.id || ret.ID,
                  label: `${ret.org_code || ret.RetailerCode} - ${
                    ret.business_name || ret.Shop_Name
                  }`,
                }))}
                value={
                  retailers
                    .map((ret) => ({
                      value: ret.id || ret.ID,
                      label: `${ret.org_code || ret.RetailerCode} - ${
                        ret.business_name || ret.Shop_Name
                      }`,
                    }))
                    .find((opt) => opt.value === selectedRetailer) || null
                }
                onChange={(option) => setSelectedRetailer(option?.value || "")}
                placeholder={`Select from ${totalRetailers} users...`}
                isClearable
                isDisabled={!selectedRole}
              />
            </div>


            {/* ✅ Key Type */}
            <div>
              <label className="text-sm font-medium text-gray-700 mb-1 block">
                Key Type
              </label>
              <select
                value={keyType}
                onChange={(e) => {
                  setKeyType(e.target.value);
                  setPackageType("");
                }}
                className="w-full rounded-lg border px-3 py-2 text-sm"
              >
                <option value="Smart">Smart</option>
                <option value="Regular">Regular</option>
              </select>
            </div>

            {/* ✅ Package Type */}
            <div>
              <label className="text-sm font-medium text-gray-700 mb-1 block">
                Package Type
              </label>

              {keyType === "Regular" ? (
                // 🧭 Show message instead of dropdown
                <div className="w-full rounded-lg border px-3 py-2 text-sm bg-gray-100 text-gray-500">
                  No package for selected key type
                </div>
              ) : (
                // 🧭 Show dropdown when Smart selected
                <select
                value={packageType}
                onChange={(e) => setPackageType(e.target.value)}
                className="w-full rounded-lg border px-3 py-2 text-sm"
              >
                <option value="">Select Package</option>
                {filteredPackages.map((pkg) => (
                  <option key={pkg.id} value={pkg.id}>
                    {pkg.package_name} - {pkg.qty}
                  </option>
                ))}
              </select>

              )}
            </div>

            {/* ✅ Number of Keys */}
            <div>
              <label className="text-sm font-medium text-gray-700 mb-1 block">
                Number of Keys
              </label>
              <input
                type="number"
                placeholder="Enter number of keys"
                value={numKeys}
                onChange={(e) => {
                  const value = parseInt(e.target.value || "0", 10);
                  const selectedPkg = filteredPackages.find(
                    (pkg) => pkg.package_name === packageType
                  );
                  const maxAllowed = selectedPkg ? selectedPkg.qty : Infinity;
                  if (value <= maxAllowed) setNumKeys(e.target.value);
                  else setNumKeys(maxAllowed.toString());
                }}
                className="w-full rounded-lg border px-3 py-2 text-sm"
              />
            </div>

            {/* ✅ Key Rate */}
            <div>
              <label className="text-sm font-medium text-gray-700 mb-1 block">
                Key Rate
              </label>
              <input
                type="number"
                placeholder="Enter key rate"
                value={keyRate}
                onChange={(e) => setKeyRate(e.target.value)}
                className="w-full rounded-lg border px-3 py-2 text-sm"
              />
            </div>

            {/* ✅ Total Amount */}
            <div>
              <label className="text-sm font-medium text-gray-700 mb-1 block">
                Total Amount
              </label>
              <input
                type="text"
                placeholder="Total Amount"
                value={totalAmount}
                readOnly
                className="w-full rounded-lg border px-3 py-2 text-sm bg-gray-100"
              />
            </div>

            {/* ✅ Assign Button */}
            <div className="sm:col-span-2 flex justify-end mt-4">
              <BlueButton brand={BRAND} onClick={handleAssign}>
                Assign
              </BlueButton>
            </div>
          </div>
        </Card>

      )}

      {tab === "receive" && (
       <ReceivedKeysTable
          brand={BRAND}
          loginUserID={loginUserID}
          CompanyID={CompanyID}
        />
      )}

      {tab === "report" && (
        <AssignedKeysReport brand={BRAND} loginUserID={loginUserID} CompanyID={CompanyID} />
      )}

      {tab === "pullback-report" && (
        <PullbackKeysReport brand={BRAND} CompanyID={CompanyID} />
      )}

      {tab === "retailer-balance" && (
        <Card brand={BRAND} title="Retailer Balance">

          {/* ✅ Role-based Sub Tabs */}
          <div className="flex flex-wrap gap-2 mb-4">
            {(() => {
              const userRole = authUser?.data[0]?.role;
              const tabsToShow = [];

              if (userRole === 2)
                tabsToShow.push("cnf", "superstockist", "distributor", "retailer");
              else if (userRole === 3)
                tabsToShow.push("superstockist", "distributor", "retailer");
              else if (userRole === 4)
                tabsToShow.push("distributor", "retailer");
              else if (userRole === 5) tabsToShow.push("retailer");

              const labels = {
                cnf: "CNF",
                superstockist: "Super Stockist",
                distributor: "Distributor",
                retailer: "Retailer",
              };

              return tabsToShow.map((t) => (
                <button
                  key={t}
                  onClick={() => setBalanceTab(t)} // ✅ Stores lowercase value (e.g., "superstockist")
                  className={`px-3 py-1 rounded-md text-sm transition-all duration-200 ${
                    balanceTab === t
                      ? "bg-blue-600 text-white shadow-md" // ✅ Active tab blue
                      : "bg-gray-100 hover:bg-gray-200 text-gray-700"
                  }`}
                >
                  {labels[t]}
                </button>
              ));
            })()}
          </div>

          <div className="flex flex-wrap justify-end gap-3 mb-4">
            <input
              type="text"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              placeholder="Search by Vendor Code or Name"
              className="border rounded px-3 py-1 text-sm"
            />


            <div className="flex flex-wrap items-center gap-4">
              <div className="flex items-center gap-2">
                <label className="text-sm font-medium text-gray-700">Date Range:</label>
                <div className="border rounded-lg px-3 py-1 shadow-sm focus-within:ring-2 focus-within:ring-indigo-400">
                  <DatePicker
                    selectsRange
                    startDate={fromDate1 ? new Date(fromDate1) : null}
                    endDate={toDate1 ? new Date(toDate1) : null}
                    onChange={(dates) => {
                      const [start, end] = dates;
                      setFromDate1(start ? start.toISOString().split("T")[0] : "");
                      setToDate1(end ? end.toISOString().split("T")[0] : "");
                    }}
                    dateFormat="yyyy-MM-dd"
                    placeholderText="Select date range"
                    className="text-sm text-gray-700 bg-transparent outline-none w-64"
                  />
                </div>
              </div>
            </div>


            <BlueButton
              brand={BRAND}
              onClick={() => {
                setSearchTerm("");
                setFromDate1("");
                setToDate1("");
              }}
              className="px-3 py-1 rounded bg-gray-100"
            >
              Reset
            </BlueButton>

            {/* <BlueButton brand={BRAND} onClick={() => {fetch()}} className="inline-flex items-center gap-1">
              <RefreshCw size={14} /> Refresh
            </BlueButton> */}

            <BlueButton
              brand={BRAND}
              onClick={handleDownload}
              className="inline-flex items-center gap-1"
            >
              <i className="ri-download-2-line"></i> Download
            </BlueButton>

          </div>


          {/* ✅ Balance Table */}
          {loadingBalance ? (
            <TableSkeleton rows={balanceData?.length || rowsPerPage} headers={[
                    "#",
                    "User Code",
                    "User Name",
                    ...(balanceTab === "cnf"
                      ? ["Company"]
                      : balanceTab === "superstockist"
                      ? ["Company", "CNF"]
                      : balanceTab === "distributor"
                      ? ["Company", "CNF", "Super Stockist"]
                      : balanceTab === "retailer"
                      ? ["Company", "CNF", "Super Stockist", "Distributor"]
                      : []),
                    "Assign Date",
                    "Remaining",
                  ]}/>
          ) : errorBalance ? (
            <p className="text-red-500">{errorBalance}</p>
          ) : balanceData.length === 0 ? (
            <p>No balance data found</p>
          ) : (
            <>
              <SimpleTable
                  headers={[
                    "#",
                    "User Code",
                    "User Name",
                    ...(balanceTab === "cnf"
                      ? ["Company"]
                      : balanceTab === "superstockist"
                      ? ["Company", "CNF"]
                      : balanceTab === "distributor"
                      ? ["Company", "CNF", "Super Stockist"]
                      : balanceTab === "retailer"
                      ? ["Company", "CNF", "Super Stockist", "Distributor"]
                      : []),
                    "Assign Date",
                    "Remaining",
                  ]}
                  rows={currentRows.map((item, i) => {
                    const baseRow = [
                      (currentPage - 1) * rowsPerPage + i + 1, // #
                      item.receiver_code || "N/A",              // User Code
                      item.receiver_name || item.name,          // User Name
                    ];

                    const dynamicColumns =
                      balanceTab === "cnf"
                        ? [item.company_name]
                        : balanceTab === "superstockist"
                        ? [item.company_name, item.cnf_name || "-"]
                        : balanceTab === "distributor"
                        ? [item.company_name, item.cnf_name || "-", item.ss_name || "-"]
                        : balanceTab === "retailer"
                        ? [
                            item.company_name,
                            item.cnf_name || "-",
                            item.ss_name || "-",
                            item.distributor_name || "-",
                          ]
                        : [];

                    // 🔹 Format Assign Date nicely
                    const assignDate = item.created_at
                      ? new Date(item.created_at).toLocaleDateString("en-GB", {
                          day: "2-digit",
                          month: "short",
                          year: "numeric",
                        })
                      : "-";

                    return [
                      ...baseRow,
                      ...dynamicColumns,
                      assignDate, // ✅ Assign Date column
                      Badge(item.smart_qty || 0, "blue"), // ✅ Remaining
                    ];
                  })}
                />


              {/* ✅ Pagination Controls */}
                <div className="flex gap-2 justify-end mt-4 items-center">
                  {/* Prev Button */}
                  <button
                    disabled={currentPage === 1}
                    onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
                    className={`px-2 py-1 border rounded text-sm ${
                      currentPage === 1
                        ? "bg-gray-200 text-gray-400 cursor-not-allowed"
                        : "bg-white hover:bg-slate-100"
                    }`}
                  >
                    Prev
                  </button>

                  {/* Page numbers */}
                  {(() => {
                    const pages = [];
                    const maxVisible = 5; // show up to 5 pages
                    let start = Math.max(1, currentPage - 2);
                    let end = Math.min(totalPages, start + maxVisible - 1);

                    if (end - start < maxVisible - 1) {
                      start = Math.max(1, end - maxVisible + 1);
                    }

                    if (start > 1) {
                      pages.push(1);
                      if (start > 2) pages.push("...");
                    }

                    for (let i = start; i <= end; i++) {
                      pages.push(i);
                    }

                    if (end < totalPages) {
                      if (end < totalPages - 1) pages.push("...");
                      pages.push(totalPages);
                    }

                    return pages.map((p, idx) =>
                      p === "..." ? (
                        <span key={idx} className="px-2 text-gray-500">
                          ...
                        </span>
                      ) : (
                        <button
                          key={p}
                          onClick={() => setCurrentPage(p)}
                          className={`px-2 py-1 border rounded text-sm ${
                            currentPage === p
                              ? "bg-blue-600 text-white"
                              : "bg-white hover:bg-slate-100"
                          }`}
                        >
                          {p}
                        </button>
                      )
                    );
                  })()}

                  {/* Next Button */}
                  <button
                    disabled={currentPage === totalPages}
                    onClick={() => setCurrentPage((p) => Math.min(p + 1, totalPages))}
                    className={`px-2 py-1 border rounded text-sm ${
                      currentPage === totalPages
                        ? "bg-gray-200 text-gray-400 cursor-not-allowed"
                        : "bg-white hover:bg-slate-100"
                    }`}
                  >
                    Next
                  </button>
                </div>
            </>
          )}
        </Card>
      )}


      {tab === "pullback" && userRole === 2 && <PullBackFlow />}
    </div>
  );
}


// import { useState, useEffect } from "react";
// import axios from "axios";
// import Header from "../Components/Header";
// import Card from "../Components/Card";
// import { BRAND } from "../css/brand";
// import TabButton from "../Components/Tabbutton";
// import Badge from "../Components/Badge";
// import BlueButton from "../Components/BlueButton";
// import SimpleTable from "../Components/SimpleTable";
// import PullBackFlow from "./PullBackFlow";
// import Select from "react-select";
// import Swal from "sweetalert2";

// export default function Keys({ role }) {
//   const [tab, setTab] = useState("assign");

//   // Assign Key States
//   const [keyType, setKeyType] = useState("Smart");
//   const [packageType, setPackageType] = useState("");
//   const [numKeys, setNumKeys] = useState("");
//   const [keyRate, setKeyRate] = useState("");
//   const [totalAmount, setTotalAmount] = useState("");
//   const [selectedRetailer, setSelectedRetailer] = useState("");
//   const [retailers, setRetailers] = useState([]);
//   const [totalRetailers, setTotalRetailer] = useState(0);
//   const [packages, setPackages] = useState([]);

//   const authUserString = sessionStorage.getItem("authUserData1");
//   const authUser = JSON.parse(authUserString);
//   const loginUserID = authUser?.id;
//   const CompanyID = authUser?.company_id;

//   // Fetch 100 retailers for dropdown
//   useEffect(() => {
//     if (!loginUserID) return;
//     axios
//       .get(
//         `https://spillas.comapi/v1/get-allretailers2?page=1&per_page=100&company_id=${loginUserID}`
//       )
//       .then((res) => {
//         const data = res.data.data.data || [];
//         setRetailers(data);
//         setTotalRetailer(res.data.data.total);
//       })
//       .catch((err) => console.error("Failed to load retailers:", err));
//   }, [loginUserID]);

//   // Fetch available packages
//   useEffect(() => {
//     if (!loginUserID) return;
//     axios
//       .get(
//         `https://spillas.comapi/v1/keys/all-my-package-list?receiver_id=${loginUserID}`
//       )
//       .then((res) => setPackages(res.data.data || []))
//       .catch((err) => console.error(err));
//   }, [loginUserID]);

//   // Auto calculate total
//   useEffect(() => {
//     const total = parseInt(numKeys || 0) * parseFloat(keyRate || 0);
//     setTotalAmount(isNaN(total) ? "" : total.toFixed(2));
//   }, [numKeys, keyRate]);

//   // Filter packages by key type
//   const filteredPackages = packages.filter((pkg) => {
//     if (keyType === "Regular") return pkg.key_type === 1;
//     if (keyType === "Smart") return pkg.key_type === 2;
//     return false;
//   });

//   // Handle Assign API
//   const handleAssign = async () => {
//     const selectedPkg = packages.find((pkg) => pkg.package_name === packageType);
//     if (!selectedPkg) {
//       Swal.fire("Error", "Please select a package", "error");
//       return;
//     }

//     const selectedRetailerData = retailers.find((r) => r.ID === selectedRetailer);
//     if (!selectedRetailerData) {
//       Swal.fire("Error", "Please select a retailer", "error");
//       return;
//     }

//     const payload = {
//       sender_id: authUser?.id,
//       sender_name: authUser?.business_name,
//       sender_code: authUser?.org_code,
//       receiver_name: selectedRetailerData.Shop_Name,
//       receiver_code: selectedRetailerData.RetailerCode,
//       receiver_id: selectedRetailerData.USerID,
//       package_name: selectedPkg.package_name,
//       key_rate: keyRate,
//       qty: numKeys,
//       amount: totalAmount,
//       product_id: selectedPkg.product_id,
//       key_type: selectedPkg.key_type,
//       mode: 1,
//       company_id: CompanyID,
//       dist_id: authUser?.id,
//       role: selectedRetailerData.Role,
//       user_package_id: selectedPkg.id,
//       created_by_id: authUser?.id,
//       created_by_name: authUser?.business_name,
//       created_by_code: authUser?.org_code,
//       sender_package_id: selectedPkg.id,
//       customer_id: selectedRetailerData.contact_id?.toString(),
//       bill_type: "Rebilling",
//       is_warranty: selectedPkg.is_warranty,
//     };

//     Swal.fire({
//       title: `Assigning keys to ${selectedRetailerData.Shop_Name}...`,
//       text: "Please wait",
//       allowOutsideClick: false,
//       didOpen: () => Swal.showLoading(),
//     });

//     try {
//       await axios.post(
//         "https://spillas.comapi/v1/keys/assign-without-zoho",
//         payload
//       );
//       Swal.fire(
//         "Success ✅",
//         `Keys assigned successfully to ${selectedRetailerData.Shop_Name}`,
//         "success"
//       );

//       // Reset form
//       setPackageType("");
//       setNumKeys("");
//       setKeyRate("");
//       setTotalAmount("");
//       setSelectedRetailer("");
//     } catch (err) {
//       console.error(err);
//       Swal.fire("Error ❌", "Failed to assign keys. Please try again.", "error");
//     }
//   };

//   return (
//     <div className="space-y-3 sm:space-y-4">
//       <Header brand={BRAND} title="Keys">
//         <div className="flex gap-2 text-xs sm:text-sm">
//           <TabButton active={tab === "assign"} onClick={() => setTab("assign")}>Assign</TabButton>
//           <TabButton active={tab === "receive"} onClick={() => setTab("receive")}>Receive</TabButton>
//           <TabButton active={tab === "report"} onClick={() => setTab("report")}>Assigned Report</TabButton>
//           <TabButton active={tab === "retailer-balance"} onClick={() => setTab("retailer-balance")}>Retailer Balance</TabButton>
//           {role === "Company" && <TabButton active={tab === "pullback"} onClick={() => setTab("pullback")}>Pull Back</TabButton>}
//         </div>
//       </Header>

//       {/* ==================== Assign Keys ==================== */}
//       {tab === "assign" && (
//         <Card brand={BRAND} title="Assign Keys">
//           <div className="grid grid-cols-1 gap-3 sm:grid-cols-6">
//             {/* Retailer Select */}
//             <div className="sm:col-span-3">
//               <Select
//                 options={retailers.map((ret) => ({
//                   value: ret.ID,
//                   label: `${ret.Shop_Name} - ${ret.RetailerCode}`,
//                 }))}
//                 value={
//                   retailers
//                     .map((ret) => ({
//                       value: ret.ID,
//                       label: `${ret.Shop_Name} - ${ret.RetailerCode}`,
//                     }))
//                     .find((opt) => opt.value === selectedRetailer) || null
//                 }
//                 onChange={(option) => setSelectedRetailer(option?.value || "")}
//                 placeholder={`Select from ${totalRetailers} Retailers...`}
//                 isClearable
//               />
//             </div>

//             {/* Key Type */}
//             <select
//               value={keyType}
//               onChange={(e) => {
//                 setKeyType(e.target.value);
//                 setPackageType("");
//               }}
//               className="rounded-lg border px-3 py-2 text-sm"
//             >
//               <option value="Smart">Smart</option>
//               <option value="Regular">Regular</option>
//             </select>

//             {/* Package Type */}
//             <select
//               value={packageType}
//               onChange={(e) => setPackageType(e.target.value)}
//               className="rounded-lg border px-3 py-2 text-sm"
//             >
//               <option value="">Select Package</option>
//               {filteredPackages.map((pkg) => (
//                 <option key={pkg.id} value={pkg.package_name}>
//                   {pkg.package_name} - {pkg.balance_keys}
//                 </option>
//               ))}
//             </select>

//             {/* Number of Keys */}
//             <input
//               type="number"
//               placeholder="Number of Keys"
//               value={numKeys}
//               onChange={(e) => {
//                 const value = parseInt(e.target.value || "0", 10);
//                 const selectedPkg = filteredPackages.find(
//                   (pkg) => pkg.package_name === packageType
//                 );
//                 const maxAllowed = selectedPkg ? selectedPkg.balance_keys : Infinity;
//                 if (value <= maxAllowed) {
//                   setNumKeys(e.target.value);
//                 } else {
//                   setNumKeys(maxAllowed.toString());
//                 }
//               }}
//               className="rounded-lg border px-3 py-2 text-sm"
//             />

//             {/* Key Rate */}
//             <input
//               type="number"
//               placeholder="Key Rate"
//               value={keyRate}
//               onChange={(e) => setKeyRate(e.target.value)}
//               className="rounded-lg border px-3 py-2 text-sm"
//             />

//             {/* Total Amount */}
//             <input
//               type="text"
//               placeholder="Total Amount"
//               value={totalAmount}
//               readOnly
//               className="rounded-lg border px-3 py-2 text-sm bg-gray-100"
//             />

//             {/* Assign Button */}
//             <div className="flex items-center justify-end sm:col-span-6">
//               <BlueButton brand={BRAND} onClick={handleAssign}>Assign</BlueButton>
//             </div>
//           </div>
//         </Card>
//       )}

//       {/* Other tabs (Receive, Report, Retailer Balance, PullBackFlow) remain same */}
//       {tab === "receive" && (
//         <Card brand={BRAND} title="Receive Keys from Company">
//           <p className="text-sm text-gray-600">Coming soon...</p>
//         </Card>
//       )}

//       {tab === "pullback" && role === "Company" && <PullBackFlow />}
//     </div>
//   );
// }


// import { useState } from "react";
// import Header from "../Components/Header";
// import Card from "../Components/Card";
// import { BRAND } from "../css/brand";
// import TabButton from "../Components/Tabbutton";
// import Badge from "../Components/Badge";
// import BlueButton from "../Components/BlueButton";
// import SimpleTable from "../Components/SimpleTable";
// import PullBackFlow from "./PullBackFlow";
// export default function Keys({ role }) {
//   const [tab, setTab] = useState("assign");
//   return (
//     <div className="space-y-3 sm:space-y-4">
//       <Header brand={BRAND} title="Keys">
//         <div className="flex gap-2 text-xs sm:text-sm">
//           <TabButton active={tab === "assign"} onClick={() => setTab("assign")}>Assign</TabButton>
//           <TabButton active={tab === "receive"} onClick={() => setTab("receive")}>Receive</TabButton>
//           <TabButton active={tab === "report"} onClick={() => setTab("report")}>Assigned Report</TabButton>
//           <TabButton active={tab === "retailer-balance"} onClick={() => setTab("retailer-balance")}>Retailer Balance</TabButton>
//           {role === "Company" && <TabButton active={tab === "pullback"} onClick={() => setTab("pullback")}>Pull Back</TabButton>}
//         </div>
//       </Header>

//       {tab === "assign" && (
//         <Card brand={BRAND} title="Assign Keys">
//           <div className="grid grid-cols-1 gap-3 sm:grid-cols-6">
//             <select className="rounded-lg border px-3 py-2 text-sm"><option>Regular</option><option>Smart</option></select>
//             <select className="rounded-lg border px-3 py-2 text-sm"><option>Regular Key</option><option>Regular + Warranty</option><option>Smart Key</option></select>
//             <input placeholder="Assign To (ID)" className="rounded-lg border px-3 py-2 text-sm" />
//             <input placeholder="Start Key (GE-1000)" className="rounded-lg border px-3 py-2 text-sm" />
//             <input placeholder="End Key (GE-1050)" className="rounded-lg border px-3 py-2 text-sm" />
//             <div className="flex items-center justify-end"><BlueButton brand={BRAND}>Assign</BlueButton></div>
//           </div>
//         </Card>
//       )}

//       {tab === "receive" && (
//         <Card brand={BRAND} title="Receive Keys from Company">
//           <div className="grid grid-cols-1 gap-3 sm:grid-cols-5">
//             <select className="rounded-lg border px-3 py-2 text-sm"><option>Regular</option><option>Smart</option></select>
//             <input placeholder="GRN / Ref No" className="rounded-lg border px-3 py-2 text-sm" />
//             <input placeholder="Start Key" className="rounded-lg border px-3 py-2 text-sm" />
//             <input placeholder="End Key" className="rounded-lg border px-3 py-2 text-sm" />
//             <div className="flex items-center justify-end"><BlueButton brand={BRAND}>Receive</BlueButton></div>
//           </div>
//         </Card>
//       )}

//       {tab === "report" && (
//         <Card brand={BRAND} title="Assigned Keys Report">
//           <SimpleTable headers={["Date", "Assigned To", "Type", "Package", "Range", "Count", "Status"]} rows={[["2025-09-22", "DST-101", "Regular", "Regular + Warranty", "GE-1000…1030", "31", Badge("Completed")],["2025-09-21", "RT-1002", "Smart", "Smart Key", "GE-0900…0925", "26", Badge("Pending", "red")]]} />
//         </Card>
//       )}

//       {tab === "retailer-balance" && (
//         <Card brand={BRAND} title="Retailer Key Balance (Regular & Smart)">
//           <SimpleTable headers={["Retailer (Code)", "Regular Keys", "Smart Keys", "Total"]} rows={[["Maha Mobile Hub (RT-1001)", "120", "86", "206"],["Ganesh Telecom (RT-1002)", "44", "21", "65"],["Sai Krupa (RT-1003)", "0", "0", "0"]]} />
//         </Card>
//       )}

//       {tab === "pullback" && role === "Company" && <PullBackFlow />}
//     </div>
//   );
// }